import { COUNTRY_CODE } from '@cemex-core/cmx-api';
import { ORDER_EXPERIENCES } from '@ordersnproducts/modules/shared/constants/order-experiences';

export const VL_COUNTRIES = [COUNTRY_CODE.USA];
export const VL_EXPERIENCES = [ORDER_EXPERIENCES.COMMAND_UNIVERSAL_LINK, ORDER_EXPERIENCES.ARKIK_UNIVERSAL_LINK];
